import { render, staticRenderFns } from "./getCouponInfo.vue?vue&type=template&id=dfd6a316&scoped=true&"
import script from "./getCouponInfo.vue?vue&type=script&lang=js&"
export * from "./getCouponInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd6a316",
  null
  
)

component.options.__file = "getCouponInfo.vue"
export default component.exports